import { useState, useMemo } from 'react'
import { DataProviderContext } from './DataProviderContext'

export function DataProvider({ children, data }) {
    const [currentData, setCurrentData] = useState(data)
    const functionalState = useMemo(
        () => ({
            data: currentData,
            setData: (dataUpdate) => {
                setCurrentData({ ...currentData, ...dataUpdate })
            }
        }),
        [currentData]
    )
    return (
        <DataProviderContext.Provider value={functionalState}>
            {children}
        </DataProviderContext.Provider>
    )
}
